<template>
  <div class="lang">
    <ul>
      <li :class="$i18n.locale == 'kg' ? 'active' : ''">
        <a
          href="#"
          :class="$i18n.locale == 'kg' ? 'active' : ''"
          :aria-current="$i18n.locale == 'kg' ? 'true' : null"
          @click.prevent="changeLangAction('kg')"
        >
          Кырг
        </a>
      </li>
      <li :class="$i18n.locale == 'ru' ? 'active' : ''">
        <a
          href="#"
          :class="$i18n.locale == 'ru' ? 'active' : ''"
          :aria-current="$i18n.locale == 'ru' ? 'true' : null"
          @click.prevent="changeLangAction('ru')"
        >
          Рус
        </a>
      </li>

    </ul>
  </div>
</template>
<script>
import {Trans} from '@/plugins/Translation'

export default {
  methods: {
    changeLangAction(locale) {
      if (this.$i18n.locale !== locale) {
        const to = this.$router.resolve({params: {locale}})
        return Trans.changeLocale(locale).then(() => {
          this.$router.push(to.location)
          window.location.reload()
        })
      }
    }
  }
}
</script>
